<template>
	<div class="login-content">
		<vs-input
			v-validate="'required'"
			data-vv-validate-on="blur"
			name="email"
			icon-no-border
			icon="icon icon-user"
			icon-pack="feather"
			label-placeholder="Tên đăng nhập"
			v-model="email"
			class="w-full"
		/>
		<span class="text-danger text-sm">{{ errors.first("email") }}</span>

		<vs-input
			@keyup.enter.native="loginJWT"
			data-vv-validate-on="blur"
			v-validate="'required'"
			type="password"
			name="password"
			icon-no-border
			icon="icon icon-lock"
			icon-pack="feather"
			label-placeholder="Mật khẩu"
			v-model="password"
			class="w-full mt-6"
		/>
		<span class="text-danger text-sm">{{ errors.first("password") }}</span>

		<div class="flex flex-wrap justify-between my-5">
			<!-- <vs-checkbox v-model="checkbox_remember_me" class="mb-3">Remember Me</vs-checkbox> -->
			<!-- <router-link to="/pages/forgot-password">Quên mật khẩu?</router-link> -->
			<router-link to="#">Quên mật khẩu?</router-link>
		</div>
		<div class="flex flex-wrap justify-center mb-3">
			<vs-button :disabled="!validateForm" @click="loginJWT">Vào hệ thống</vs-button>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			email: "",
			password: "",
			checkbox_remember_me: true
		};
	},
	computed: {
		validateForm() {
			return !this.errors.any() && this.email != "" && this.password != "";
		}
	},
	methods: {
		checkLogin() {
			// If user is already logged in notify
			if (this.$store.state.auth.isUserLoggedIn()) {
				// Close animation if passed as payload
				// this.$vs.loading.close()

				this.$vs.notify({
					title: "Login Attempt",
					text: "You are already logged in!",
					iconPack: "feather",
					icon: "icon-alert-circle",
					color: "warning"
				});

				return false;
			}
			return true;
		},
		loginJWT() {
			if (!this.checkLogin()) return;

			// Loading
			this.$vs.loading();

			const payload = {
				checkbox_remember_me: this.checkbox_remember_me,
				userDetails: {
					email: this.email,
					password: this.password
				}
			};

			this.$store
				.dispatch("auth/loginJWT", payload)
				.then(() => {
					this.$vs.loading.close();

					if (typeof localStorage === 'object' && localStorage) {
						let forceRelogin = localStorage.setItem('relogin', '1');
					}

					window.location.reload();
				})
				.catch(error => {
					this.$vs.loading.close();
					this.$vs.notify({
						title: "Error",
						text: error.message,
						iconPack: "feather",
						icon: "icon-alert-circle",
						color: "danger"
					});
				});
		},
		registerUser() {
			if (!this.checkLogin()) return;
			this.$router.push("/pages/register").catch(() => {});
		}
	},
};
</script>

<style lang="scss">
.login-content input:-webkit-autofill  ~span {
	-webkit-transform: translate(-3px,-90%)!important;
	transform: translate(-3px,-90%)!important;
	padding-left: 3rem !important;
	font-size: .7rem !important;
	padding-top: 1rem !important;
}

// .login-content input {
// 	margin-bottom: 1rem !important;
// }
</style>